<script>
import ProfilePicture from '@components/profile-picture.vue'
import MottoIcon from '@components/motto-icon.vue'
import CopyToClipboardButton from '@components/copy-to-clipboard-button.vue'
import { isMobileMixin } from '@src/mixins/isMobileMixin'
export default {
  components: {
    ProfilePicture,
    MottoIcon,
    CopyToClipboardButton,
  },
  mixins: [isMobileMixin],
  props: {
    primaryOpsContact: {
      type: Object,
      required: true,
    },
  },
  computed: {
    role() {
      return this.primaryOpsContact?.jobTitle
    },
  },
  methods: {
    formatPhoneWithDashes(phone) {
      const onlyNumbers = phone.replace(/\D/g, '')
      return `${onlyNumbers.substr(0, 3)}-${onlyNumbers.substr(3, 3)}-${onlyNumbers.substr(6, 4)}`
    },

    handlePhoneClick() {
      if (this.isMobile) {
        window.open(`tel:${this.primaryOpsContact.phone}`)
      }
    },

    openCalendly() {
      window.open(this.primaryOpsContact.calendlyLink, '_blank')
    },
  },
}
</script>

<template>
  <div :class="[$style.primaryOpsContactContainer]">
    <div class="d-flex">
      <ProfilePicture :class="$style.profilePicture" :src="primaryOpsContact.photoUrl" />
      <div :class="$style.contentContainer">
        <div class="text-center">
          <p :class="$style.name" class="button-text color-primary-blue">
            {{ primaryOpsContact.firstName }} {{ primaryOpsContact.lastName }}
          </p>
          <p class="p2 color-primary-blue mb-2">{{ role }}</p>
        </div>

        <div :class="$style.buttonContainer">
          <MottoIcon
            id="primary-ops-phone"
            tabindex="0"
            name="Phone"
            icon-color="green"
            @click.native="handlePhoneClick" />
          <b-tooltip
            :triggers="isMobile ? '' : 'click blur'"
            target="primary-ops-phone"
            :placement="`top`"
            :custom-class="`tooltipBlue ${$style.copyToClipboardTooltip}`">
            <span class="px-1 py-1" style="font-size: 16px">
              {{ formatPhoneWithDashes(primaryOpsContact.phone) }}
            </span>
            <CopyToClipboardButton :text-to-copy="primaryOpsContact.phone" theme="square" icon="Copy" />
          </b-tooltip>
          <a :href="`mailto:${primaryOpsContact.primaryEmail}`"><MottoIcon name="Envelope" icon-color="green" /></a>
          <MottoIcon
            v-if="primaryOpsContact.calendlyLink"
            name="Calendar"
            icon-color="green"
            @click.native="openCalendly" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.profilePicture {
  @media (max-width: $min-width-breakpoint + 20px) {
    margin-left: 0 !important;
  }

  @media (min-width: $min-width-breakpoint + 20px) and (max-width: $sm-breakpoint - 100px) {
    margin-left: 0 !important;
  }

  width: 100%;
  max-width: 73.3px;
  height: fit-content;
  margin: auto 0 auto 2px;
}

.contentContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 6px 10px 6px 6px;
}

.primaryOpsContactContainer {
  @media (max-width: $lg-breakpoint) {
    min-width: unset;
  }

  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 300px;
  padding: 6px;
  background-color: $lightest-gray;
  border: $primary-slate 2px solid;
  border-radius: 16px;
  box-shadow: 3px 3px 6px rgba(196, 196, 196, 0.9);
}

.name {
  word-break: break-word;
}

.buttonContainer {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  min-width: 120px;
  margin-top: auto;

  > div {
    cursor: pointer;
  }

  svg {
    width: 30px;
    height: 30px;
  }
}

.copyToClipboardTooltip {
  div[class='tooltip-inner'] {
    display: flex;
    align-items: center;
    gap: 0 15px;
  }
}
</style>
